module.exports = __webpack_public_path__ + "media/כוכב.d60f04c3.mp3";